import { useParams } from 'react-router-dom';
import FullScreenLayout from '../../../components/FullScreenLayout';
import { ChatList } from '../../../features/chat/components/ChatList';
import { ChatSessionScreen } from '../../../features/chat/components/chatSession/ChatSessionScreen';
import useGetChatSessions from '../../../features/chat/hooks/useGetChatSessions';
import { ChatSession } from '../../../features/chat/types/ChatSession';

const Chat = () => {
  const { chatSessionId } = useParams();
  const {
    data: chatSessions,
    isLoading,
    isError,
    isFetching,
  } = useGetChatSessions();
  
  if (isLoading) {
    return (
      <FullScreenLayout title="Caricamento...">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div>
            Attendi un attimo... <br />
            Stiamo caricando le conversazioni
          </div>
        </div>
      </FullScreenLayout>
    );
  }
  
  if (isError) {
    return (
      <FullScreenLayout title="Errore">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div>
            Errore nel caricamento delle conversazioni
          </div>
        </div>
      </FullScreenLayout>
    );
  }
  
  if (!chatSessionId) {
    return <ChatList />;
  }
  
  const chatSession = chatSessions?.find(
    (session: ChatSession) => session.id === chatSessionId,
  );

  if (!chatSession) {
    if (isFetching) {
      return (
        <FullScreenLayout title="Caricamento...">
          <div className="w-full h-full flex flex-col items-center justify-center">
            <div>
              Attendi un attimo... <br />
              Stiamo caricando la conversazione
            </div>
          </div>
        </FullScreenLayout>
      );
    }
    
    return (
      <FullScreenLayout title="Conversazione non trovata">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div>
            Conversazione non trovata
          </div>
        </div>
      </FullScreenLayout>
    );
  }

  return (
    <div className='w-full h-full'>
      <ChatSessionScreen chatSession={chatSession} />
    </div>
  );
};

export default Chat;
